export const STORY_STAGES = [
  { id: "IDEA", label: "Idea / Pitch" },
  { id: "ASSIGNED", label: "Asignada" },
  { id: "IN_PROGRESS", label: "En progreso" },
  { id: "REVIEW", label: "Lista para revisión" },
  { id: "READY_WEBFLOW", label: "Lista para Webflow" },
  { id: "PUBLISHED", label: "Publicada" },
];
export const stageLabel = (id) => STORY_STAGES.find((s) => s.id === id)?.label || id;

export const FORMATS = [
  { id: "DIGITAL_FEATURE", label: "Feature digital" },
  { id: "SOCIAL_VIDEO", label: "Hook de video social" },
  { id: "BOOK_ESSAY", label: "Ensayo para el Libro Anual" },
];
export const formatLabel = (id) => FORMATS.find((s) => s.id === id)?.label || id;

export const SECTIONS = ["Arte", "Conoce Now What?", "Cultura", "Eventos", "Fotografía", "Gastronomía", "Life", "Moda", "Música", "Tecnología", "Viajes"];  // 1:1 con la colección «Categorias» de Webflow

export const SCOPES = [
  { id: "LOCAL_SV", label: "El Salvador", short: "SV" },
  { id: "REGIONAL_CA", label: "Centroamérica", short: "CA" },
  { id: "GLOBAL", label: "Global", short: "GL" },
];
export const scopeLabel = (id) => SCOPES.find((s) => s.id === id)?.label || id;

export const DEAL_STAGES = [
  { id: "LEAD", label: "Lead / Inbound" },
  { id: "DISCOVERY", label: "Llamada de descubrimiento" },
  { id: "PROPOSAL", label: "Propuesta enviada" },
  { id: "NEGOTIATION", label: "Negociación de contrato" },
  { id: "WON", label: "Ganado / Reservado" },
  { id: "PAID", label: "Facturado / Pagado" },
  { id: "LOST", label: "Perdido" },
];
export const dealStageLabel = (id) => DEAL_STAGES.find((s) => s.id === id)?.label || id;

export const INVENTORY = [
  { id: "SPONSORED_WEB", label: "Historia web patrocinada" },
  { id: "SOCIAL_CAMPAIGN", label: "Campaña en redes sociales" },
  { id: "EVENT_COHOST", label: "Co-host de evento" },
  { id: "BOOK_PLACEMENT", label: "Pauta en Libro Anual" },
];
export const inventoryLabel = (id) => INVENTORY.find((s) => s.id === id)?.label || id;
export const SOCIAL_CHANNELS = ["Instagram", "TikTok", "X", "YouTube"];

export const INVOICE = [
  { id: "NONE", label: "Sin factura" },
  { id: "SENT", label: "Factura enviada" },
  { id: "PAID", label: "Pagada" },
  { id: "OVERDUE", label: "Vencida" },
];

export const PAGE_TYPES = [
  { id: "EDITORIAL_ESSAY", label: "Ensayo editorial", short: "Ensayo", cls: "pt-essay" },
  { id: "PHOTO_PORTFOLIO", label: "Portafolio fotográfico", short: "Portafolio", cls: "pt-portfolio" },
  { id: "CHAPTER_DIVIDER", label: "Divisor de capítulo", short: "Capítulo", cls: "pt-divider" },
  { id: "COVER", label: "Portada / Contraportada", short: "Portada", cls: "pt-cover" },
  { id: "AD_FULL", label: "Anuncio página completa", short: "Anuncio", cls: "pt-ad" },
  { id: "AD_DOUBLE", label: "Anuncio doble página", short: "Anuncio doble", cls: "pt-ad" },
  { id: "EMPTY", label: "Sin asignar", short: "Libre", cls: "" },
];
export const pageType = (id) => PAGE_TYPES.find((p) => p.id === id) || PAGE_TYPES[6];
export const AD_PAGE_TYPES = ["AD_FULL", "AD_DOUBLE", "EMPTY"];

export const CHECKLIST = [
  { id: "textEdited", label: "Texto editado" },
  { id: "indesignSynced", label: "Maqueta InDesign sincronizada" },
  { id: "imagesChecked", label: "Imágenes en alta (300 DPI) revisadas" },
  { id: "proofsSigned", label: "Pruebas de color firmadas" },
];

export const WEBFLOW_STATUS = {
  NOT_LINKED: "No vinculado",
  DRAFT: "Sincronizado como borrador",
  LIVE: "Publicado en Webflow",
};

export const ROLE_LABEL = { SUPERADMIN: "Superadmin", EDITORIAL: "Editorial", COMMERCIAL: "Comercial" };

export const canAccess = (role, area) => {
  const map = {
    radar: ["SUPERADMIN", "EDITORIAL"],
    editorial: ["SUPERADMIN", "EDITORIAL", "COMMERCIAL"],
    editStories: ["SUPERADMIN", "EDITORIAL"],
    crm: ["SUPERADMIN", "COMMERCIAL"],
    webflow: ["SUPERADMIN", "EDITORIAL"],
    settings: ["SUPERADMIN"],
  };
  return (map[area] || []).includes(role);
};

// Permission-aware access helper. Prefer this in new code.
export const can = (me, key) => {
  if (!me) return false;
  const list = me.permissions || [];
  return list.includes("*") || list.includes(key);
};

// Sidebar area → required permission key.
export const AREA_PERMISSION = {
  radar: "access.radar",
  editorial: "access.editorial",
  flatplan: "access.flatplan",
  crm: "access.crm",
  integrations: "access.integrations",
  team: "access.team",
};

export const QUOTE_STATUSES = [
  { id: "DRAFT", label: "Borrador" },
  { id: "SENT", label: "Enviada" },
  { id: "VIEWED", label: "Vista por el cliente" },
  { id: "ACCEPTED", label: "Aceptada" },
  { id: "DECLINED", label: "Rechazada" },
  { id: "EXPIRED", label: "Vencida" },
];
export const quoteStatusLabel = (id) => QUOTE_STATUSES.find((s) => s.id === id)?.label || id;

export const PRODUCT_TYPES = [
  { id: "SPONSORED_WEB", label: "Historia web patrocinada", short: "Web branded" },
  { id: "SOCIAL_CAMPAIGN", label: "Campaña redes sociales", short: "Redes" },
  { id: "EVENT_COHOST", label: "Co-host de evento", short: "Evento" },
  { id: "BOOK_FULL_PAGE", label: "Libro Anual · página completa", short: "Libro página" },
  { id: "BOOK_DOUBLE_SPREAD", label: "Libro Anual · doble página", short: "Libro doble" },
  { id: "CUSTOM_PRODUCTION", label: "Producción a medida", short: "Producción" },
];
export const productTypeLabel = (id) => PRODUCT_TYPES.find((p) => p.id === id)?.label || id;
export const productTypeShort = (id) => PRODUCT_TYPES.find((p) => p.id === id)?.short || id;

// Pastel chart palette aligned with Mediana brand
export const PRODUCT_COLORS = {
  SPONSORED_WEB: "#C4B5FD",   // lilac
  SOCIAL_CAMPAIGN: "#FDE68A", // butter
  EVENT_COHOST: "#FBCFE8",    // blush
  BOOK_FULL_PAGE: "#A7F3D0",  // mint
  BOOK_DOUBLE_SPREAD: "#BAE6FD", // sky
  CUSTOM_PRODUCTION: "#FED7AA", // peach
};
